import * as CONSTANTS from 'app/utils/constants';

// Kept in its own module (separate from `./index.tsx`) so consumers that only
// need the types — e.g. `routeUtils.parseSignUpQueryParams` — don't pull in the
// SignUp module's top-level `loadStripe()` call and fetch js.stripe.com on
// every page load.
export interface FormState {
  accountEmail: string;
  organizationName: string;
  billingAddress: {
    line1: string;
    line2: string | null;
    city: string;
    state: string;
    postal_code: string;
    country: string;
  };
  agreeToService: boolean;
  accessSubscriptionType: CONSTANTS.LENS_ACCESS_SUBSCRIPTIONS_TYPE;
  taxExempt: boolean;
  billingEmail: string;
  subscriptionAddOns: string[];
  freeTrial?: string;
}

export const DEFAULT_FORM_STATE: FormState = {
  accessSubscriptionType: 'plus_annual',
  accountEmail: '',
  organizationName: '',
  billingAddress: {
    line1: '',
    line2: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
  },
  agreeToService: false,
  taxExempt: false,
  billingEmail: '',
  subscriptionAddOns: [],
  freeTrial: undefined,
};
